
<el-form ref="form.data" :rules="rulesForm" :model="form.data" class="form-cont">
  <div class="form-scroll">
    <div class="form-takeResa-cash" v-if="cashInfos">
      <i class="el-icon-info"></i>
      <span>Réservation avec {{ getCashTerme }} de {{ cashInfos.value }}€ par couvert, soit
        <b>{{ Math.round(cashInfos.value * this.getNbCouvert * 100) / 100 }} €.</b></span>
    </div>
    <div class="form-line">
      <el-form-item>
        <el-radio-group v-model="form.data.civ">
          <el-radio-button class="civ-m" label="M."></el-radio-button>
          <el-radio-button class="civ-f" label="Mme"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="name" class="full-width">
        <el-input v-model="form.data.name" placeholder="Nom*"></el-input>
      </el-form-item>
    </div>
    <el-form-item prop="prenom">
      <el-input v-model="form.data.prenom" placeholder="Prénom*"></el-input>
    </el-form-item>
    <el-form-item prop="email">
      <el-input v-model="form.data.email" placeholder="e-mail*"></el-input>
    </el-form-item>
    <div class="form-line">
      <el-form-item prop="telPreFix" class="tel-prefix">
        <el-input v-model="form.data.telPreFix" placeholder="+33"></el-input>
      </el-form-item>
      <el-form-item prop="tel" class="tel full-width">
        <el-input v-model="form.data.tel" placeholder="Téléphone*"></el-input>
      </el-form-item>
    </div>
    <el-form-item>
      <el-input v-model="form.data.societe" placeholder="Société"></el-input>
    </el-form-item>

    <el-form-item>
      <el-input v-model="form.data.comment" :autosize="{ minRows: 3 }" type="textarea"
        placeholder="Ajouter un commentaire, une demande, etc..."></el-input>
    </el-form-item>
    <el-form-item prop="allergen">
      <el-checkbox v-model="form.data.allergen" @change="$refs['form.data'].clearValidate()">Intolérance /
        Allergie</el-checkbox>
    </el-form-item>
    <el-form-item v-if="form.data.allergen" prop="allergenMessage">
      <el-input v-model="form.data.allergenMessage" :autosize="{ minRows: 3 }" type="textarea"
        placeholder="Merci de renseigner les intolérances / allergies"></el-input>
    </el-form-item>
  </div>

  <el-skeleton :loading="cashInfos === undefined" animated class="booking-cont">
    <template slot="template">
      <el-skeleton-item class="booking-button-loading" animated />
    </template>
    <template>
      <el-button class="booking-button" @click="obSubmit()" :loading="sendIsLoading">
        Réserver
      </el-button>
    </template>
  </el-skeleton>
</el-form>
